/**
 * Setzt die eigene Messung in die Sammelmeldung ein, wenn sie frischer ist als
 * das, was vom Server zurückkam.
 *
 * `lastReportAt` wird mitgeführt: Ohne das hörte die Karte nach
 * `extrapolationStopMs` auf, den eigenen Punkt fortzuschreiben, und liefe nach
 * `staleMs` grau — beides gerechnet auf einen Zeitpunkt, der mit dieser Messung
 * nichts zu tun hat.
 *
 * Ist die Antwort des Servers gleich alt oder frischer, bleibt alles, wie es
 * ist: Dann trägt sie dieselbe Messung und dazu die Rechnungen, die nur er
 * anstellen kann.
 */
export function withOwnMeasurement(vehicles, lastReportAt, youId, ownSample, ownSampleAt) {
    if (youId === null || ownSample === null || ownSampleAt === null) {
        return { vehicles, lastReportAt };
    }
    const gemeldet = lastReportAt.get(youId);
    if (gemeldet !== undefined && gemeldet >= ownSampleAt) {
        return { vehicles, lastReportAt };
    }
    const index = vehicles.findIndex((fahrzeug) => fahrzeug.participantId === youId);
    const eigenes = vehicles[index];
    if (eigenes === undefined) {
        /*
         * Kein eigener Eintrag in der Sammelmeldung — das ist der Augenblick
         * zwischen Beitritt und erster Antwort. Hier einen zu erfinden hieße,
         * Zustand und Rückstand zu behaupten, die noch niemand gerechnet hat.
         */
        return { vehicles, lastReportAt };
    }
    const ersetzt = {
        ...eigenes,
        lat: ownSample.lat,
        lon: ownSample.lon,
        recordedAt: ownSample.recordedAt,
        accuracyM: ownSample.accuracyM,
        speedMps: ownSample.speedMps ?? null,
        headingDeg: ownSample.headingDeg ?? null,
        /*
         * Das Alter zählt ab jetzt, nicht ab der letzten Antwort des Servers: Die
         * Messung ist gerade eingetroffen, sie ist null Sekunden alt.
         */
        reportAgeS: 0,
    };
    const zeiten = new Map(lastReportAt);
    zeiten.set(youId, ownSampleAt);
    return {
        vehicles: [...vehicles.slice(0, index), ersetzt, ...vehicles.slice(index + 1)],
        lastReportAt: zeiten,
    };
}
//# sourceMappingURL=ownPosition.js.map